/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AWSMetricDefinitionResponse } from '../model';
// @ts-ignore
import type { AWSResourceResponse } from '../model';
// @ts-ignore
import type { AWSResourceSearchRequest } from '../model';
// @ts-ignore
import type { AzureMetricDefinitionResponse } from '../model';
// @ts-ignore
import type { AzureResourceGroupResponse } from '../model';
// @ts-ignore
import type { AzureResourceResponse } from '../model';
// @ts-ignore
import type { AzureSubscriptionResponse } from '../model';
// @ts-ignore
import type { CheckCopilotStudioEnvironmentsRequest } from '../model';
// @ts-ignore
import type { ClaudeAppsCapabilities } from '../model';
// @ts-ignore
import type { CopilotStudioAgentDetailResponse } from '../model';
// @ts-ignore
import type { CopilotStudioAgentsResponse } from '../model';
// @ts-ignore
import type { CopilotStudioEnvironmentChecksResponse } from '../model';
// @ts-ignore
import type { CopilotStudioEnvironmentsResponse } from '../model';
// @ts-ignore
import type { CreateTestingMetricRequest } from '../model';
// @ts-ignore
import type { CreateTestingSourceRequest } from '../model';
// @ts-ignore
import type { DiscoverCopilotStudioEnvironmentsRequest } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { SourceConnectionHealth } from '../model';
// @ts-ignore
import type { SourceIntegration } from '../model';
// @ts-ignore
import type { TestConnection } from '../model';
// @ts-ignore
import type { TestConnectionRequest } from '../model';
// @ts-ignore
import type { TestingMetric } from '../model';
// @ts-ignore
import type { TestingMetricExternal } from '../model';
// @ts-ignore
import type { TestingSource } from '../model';
// @ts-ignore
import type { TestingTest } from '../model';
// @ts-ignore
import type { UpdateTestingSourceRequest } from '../model';
// @ts-ignore
import type { VijilMetricDefinitionResponse } from '../model';
/**
 * TestingSourceApi - axios parameter creator
 */
export const TestingSourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Run an on-demand connection check for every active source of a project
         * @summary Check All Source Connections
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAllSourceConnections: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('checkAllSourceConnections', 'projectId', projectId)
            const localVarPath = `/testing/sources/check-connections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Probe what the keys of a Claude Enterprise source can read now (one cheap call per API family), store the result on the source and return it.
         * @summary Check Claude Enterprise Capabilities
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkClaudeAppsCapabilities: async (sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('checkClaudeAppsCapabilities', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}/claude-apps/capabilities/check`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check whether the app can read agents in each picked environment of a tenant source. Checks at most 50 environments per call; the rest are returned as not_checked.
         * @summary Check Copilot Studio Environments
         * @param {string} sourceId 
         * @param {CheckCopilotStudioEnvironmentsRequest} checkCopilotStudioEnvironmentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCopilotStudioEnvironments: async (sourceId: string, checkCopilotStudioEnvironmentsRequest: CheckCopilotStudioEnvironmentsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('checkCopilotStudioEnvironments', 'sourceId', sourceId)
            // verify required parameter 'checkCopilotStudioEnvironmentsRequest' is not null or undefined
            assertParamExists('checkCopilotStudioEnvironments', 'checkCopilotStudioEnvironmentsRequest', checkCopilotStudioEnvironmentsRequest)
            const localVarPath = `/testing/sources/{source_id}/copilot-studio/environments/check`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCopilotStudioEnvironmentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new testing metric for a testing source
         * @summary Create Testing Metric
         * @param {string} sourceId 
         * @param {string} projectId 
         * @param {CreateTestingMetricRequest} createTestingMetricRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestingMetric: async (sourceId: string, projectId: string, createTestingMetricRequest: CreateTestingMetricRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('createTestingMetric', 'sourceId', sourceId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createTestingMetric', 'projectId', projectId)
            // verify required parameter 'createTestingMetricRequest' is not null or undefined
            assertParamExists('createTestingMetric', 'createTestingMetricRequest', createTestingMetricRequest)
            const localVarPath = `/testing/sources/{source_id}/metrics`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTestingMetricRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new testing source for a project
         * @summary Create Testing Source
         * @param {string} projectId 
         * @param {CreateTestingSourceRequest} createTestingSourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestingSource: async (projectId: string, createTestingSourceRequest: CreateTestingSourceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createTestingSource', 'projectId', projectId)
            // verify required parameter 'createTestingSourceRequest' is not null or undefined
            assertParamExists('createTestingSource', 'createTestingSourceRequest', createTestingSourceRequest)
            const localVarPath = `/testing/sources/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTestingSourceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a testing source
         * @summary Delete Testing Source
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTestingSource: async (sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('deleteTestingSource', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List every Power Platform environment of a tenant with its agent counts, using unsaved credentials.
         * @summary Discover Copilot Studio Environments
         * @param {string} projectId 
         * @param {DiscoverCopilotStudioEnvironmentsRequest} discoverCopilotStudioEnvironmentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discoverCopilotStudioEnvironments: async (projectId: string, discoverCopilotStudioEnvironmentsRequest: DiscoverCopilotStudioEnvironmentsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('discoverCopilotStudioEnvironments', 'projectId', projectId)
            // verify required parameter 'discoverCopilotStudioEnvironmentsRequest' is not null or undefined
            assertParamExists('discoverCopilotStudioEnvironments', 'discoverCopilotStudioEnvironmentsRequest', discoverCopilotStudioEnvironmentsRequest)
            const localVarPath = `/testing/sources/copilot-studio/environments/discover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(discoverCopilotStudioEnvironmentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one Copilot Studio agent and its components.
         * @summary Get Copilot Studio Agent
         * @param {string} agentId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCopilotStudioAgent: async (agentId: string, sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getCopilotStudioAgent', 'agentId', agentId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('getCopilotStudioAgent', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}/copilot-studio/agents/{agent_id}`
                .replace('{agent_id}', encodeURIComponent(String(agentId)))
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of supported source types
         * @summary Get Supported Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedSourceTypesForTesting: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testing/sources/supported-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific testing metric by ID
         * @summary Get Testing Metric
         * @param {string} sourceId 
         * @param {string} metricId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingMetric: async (sourceId: string, metricId: string, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('getTestingMetric', 'sourceId', sourceId)
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('getTestingMetric', 'metricId', metricId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getTestingMetric', 'projectId', projectId)
            const localVarPath = `/testing/sources/{source_id}/metrics/{metric_id}`
                .replace('{source_id}', encodeURIComponent(String(sourceId)))
                .replace('{metric_id}', encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific testing source by ID
         * @summary Get Testing Source
         * @param {string} sourceId 
         * @param {string | null} [projectId] The caller\&#39;s AI System; required to read the global source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingSource: async (sourceId: string, projectId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('getTestingSource', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Available External Metrics of Testing Source
         * @summary Get Available External Metrics of Testing Source
         * @param {string} sourceId 
         * @param {string} metricName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingSourceExternalMetrics: async (sourceId: string, metricName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('getTestingSourceExternalMetrics', 'sourceId', sourceId)
            // verify required parameter 'metricName' is not null or undefined
            assertParamExists('getTestingSourceExternalMetrics', 'metricName', metricName)
            const localVarPath = `/testing/sources/{source_id}/metrics/external`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (metricName !== undefined) {
                localVarQueryParameter['metric_name'] = metricName;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Available Metrics of Testing Source
         * @summary Get Available Metrics of Testing Source
         * @param {string} sourceId 
         * @param {string} projectId 
         * @param {string | null} [metricName] Filter by metric name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingSourceMetrics: async (sourceId: string, projectId: string, metricName?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('getTestingSourceMetrics', 'sourceId', sourceId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getTestingSourceMetrics', 'projectId', projectId)
            const localVarPath = `/testing/sources/{source_id}/metrics`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (metricName !== undefined) {
                localVarQueryParameter['metric_name'] = metricName;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all testing sources for a project
         * @summary Get Testing Sources
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingSources: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getTestingSources', 'projectId', projectId)
            const localVarPath = `/testing/sources/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all tests for a testing source
         * @summary Get Tests
         * @param {string} sourceId 
         * @param {string | null} [projectId] The caller\&#39;s AI System; required to read the global source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestsBySource: async (sourceId: string, projectId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('getTestsBySource', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}/tests`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List available CloudWatch metrics for a specific AWS resource.
         * @summary List CloudWatch metrics for an AWS resource
         * @param {string} resourceArn 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAwsResourceMetrics: async (resourceArn: string, sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceArn' is not null or undefined
            assertParamExists('listAwsResourceMetrics', 'resourceArn', resourceArn)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('listAwsResourceMetrics', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}/aws/resources/{resource_arn}/metrics`
                .replace('{resource_arn}', encodeURIComponent(String(resourceArn)))
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List resource groups in an Azure subscription
         * @summary List Azure Resource Groups
         * @param {string} subscriptionId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAzureResourceGroups: async (subscriptionId: string, sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('listAzureResourceGroups', 'subscriptionId', subscriptionId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('listAzureResourceGroups', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}/azure/subscriptions/{subscription_id}/resource-groups`
                .replace('{subscription_id}', encodeURIComponent(String(subscriptionId)))
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List available metrics for an Azure resource
         * @summary List Azure Resource Metrics
         * @param {string} resourceId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAzureResourceMetrics: async (resourceId: string, sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('listAzureResourceMetrics', 'resourceId', resourceId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('listAzureResourceMetrics', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}/azure/resources/{resource_id}/metrics`
                .replace('{resource_id}', encodeURIComponent(String(resourceId)))
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Azure subscriptions for a testing source
         * @summary List Azure Subscriptions
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAzureSubscriptions: async (sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('listAzureSubscriptions', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}/azure/subscriptions`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Copilot Studio agents visible to the source\'s service principal.
         * @summary List Copilot Studio Agents
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCopilotStudioAgents: async (sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('listCopilotStudioAgents', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}/copilot-studio/agents`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List every Power Platform environment of the source\'s tenant with its agent counts.
         * @summary List Copilot Studio Environments
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCopilotStudioEnvironments: async (sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('listCopilotStudioEnvironments', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}/copilot-studio/environments`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List available metrics from the Vijil evaluation.
         * @summary List Vijil Evaluation Metrics
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVijilMetrics: async (sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('listVijilMetrics', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}/vijil/metrics`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for AWS resources using tags, types, or name search.
         * @summary Search AWS resources
         * @param {string} sourceId 
         * @param {AWSResourceSearchRequest} aWSResourceSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAwsResources: async (sourceId: string, aWSResourceSearchRequest: AWSResourceSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('searchAwsResources', 'sourceId', sourceId)
            // verify required parameter 'aWSResourceSearchRequest' is not null or undefined
            assertParamExists('searchAwsResources', 'aWSResourceSearchRequest', aWSResourceSearchRequest)
            const localVarPath = `/testing/sources/{source_id}/aws/resources/search`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aWSResourceSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search Azure resources with optional filters
         * @summary Search Azure Resources
         * @param {string} sourceId 
         * @param {string | null} [subscriptionId] Filter by subscription ID
         * @param {string | null} [resourceGroup] Filter by resource group name
         * @param {string | null} [resourceType] Filter by resource type
         * @param {string | null} [search] Search by resource name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAzureResources: async (sourceId: string, subscriptionId?: string | null, resourceGroup?: string | null, resourceType?: string | null, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('searchAzureResources', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}/azure/resources`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (subscriptionId !== undefined) {
                localVarQueryParameter['subscription_id'] = subscriptionId;
            }

            if (resourceGroup !== undefined) {
                localVarQueryParameter['resource_group'] = resourceGroup;
            }

            if (resourceType !== undefined) {
                localVarQueryParameter['resource_type'] = resourceType;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test connection to a source before creating it
         * @summary Test Connection
         * @param {string} projectId 
         * @param {TestConnectionRequest} testConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testConnection: async (projectId: string, testConnectionRequest: TestConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('testConnection', 'projectId', projectId)
            // verify required parameter 'testConnectionRequest' is not null or undefined
            assertParamExists('testConnection', 'testConnectionRequest', testConnectionRequest)
            const localVarPath = `/testing/sources/test-connection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test connection to an existing testing source using stored credentials
         * @summary Test Existing Source Connection
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testExistingSourceConnection: async (sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('testExistingSourceConnection', 'sourceId', sourceId)
            const localVarPath = `/testing/sources/{source_id}/test-connection`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a testing source
         * @summary Update Testing Source
         * @param {string} sourceId 
         * @param {UpdateTestingSourceRequest} updateTestingSourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestingSource: async (sourceId: string, updateTestingSourceRequest: UpdateTestingSourceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('updateTestingSource', 'sourceId', sourceId)
            // verify required parameter 'updateTestingSourceRequest' is not null or undefined
            assertParamExists('updateTestingSource', 'updateTestingSourceRequest', updateTestingSourceRequest)
            const localVarPath = `/testing/sources/{source_id}`
                .replace('{source_id}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTestingSourceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestingSourceApi - functional programming interface
 */
export const TestingSourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestingSourceApiAxiosParamCreator(configuration)
    return {
        /**
         * Run an on-demand connection check for every active source of a project
         * @summary Check All Source Connections
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAllSourceConnections(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceConnectionHealth>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAllSourceConnections(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.checkAllSourceConnections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Probe what the keys of a Claude Enterprise source can read now (one cheap call per API family), store the result on the source and return it.
         * @summary Check Claude Enterprise Capabilities
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkClaudeAppsCapabilities(sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaudeAppsCapabilities>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkClaudeAppsCapabilities(sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.checkClaudeAppsCapabilities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check whether the app can read agents in each picked environment of a tenant source. Checks at most 50 environments per call; the rest are returned as not_checked.
         * @summary Check Copilot Studio Environments
         * @param {string} sourceId 
         * @param {CheckCopilotStudioEnvironmentsRequest} checkCopilotStudioEnvironmentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkCopilotStudioEnvironments(sourceId: string, checkCopilotStudioEnvironmentsRequest: CheckCopilotStudioEnvironmentsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopilotStudioEnvironmentChecksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkCopilotStudioEnvironments(sourceId, checkCopilotStudioEnvironmentsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.checkCopilotStudioEnvironments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new testing metric for a testing source
         * @summary Create Testing Metric
         * @param {string} sourceId 
         * @param {string} projectId 
         * @param {CreateTestingMetricRequest} createTestingMetricRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestingMetric(sourceId: string, projectId: string, createTestingMetricRequest: CreateTestingMetricRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestingMetric>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestingMetric(sourceId, projectId, createTestingMetricRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.createTestingMetric']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new testing source for a project
         * @summary Create Testing Source
         * @param {string} projectId 
         * @param {CreateTestingSourceRequest} createTestingSourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestingSource(projectId: string, createTestingSourceRequest: CreateTestingSourceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestingSource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestingSource(projectId, createTestingSourceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.createTestingSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a testing source
         * @summary Delete Testing Source
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTestingSource(sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTestingSource(sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.deleteTestingSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List every Power Platform environment of a tenant with its agent counts, using unsaved credentials.
         * @summary Discover Copilot Studio Environments
         * @param {string} projectId 
         * @param {DiscoverCopilotStudioEnvironmentsRequest} discoverCopilotStudioEnvironmentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discoverCopilotStudioEnvironments(projectId: string, discoverCopilotStudioEnvironmentsRequest: DiscoverCopilotStudioEnvironmentsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopilotStudioEnvironmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discoverCopilotStudioEnvironments(projectId, discoverCopilotStudioEnvironmentsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.discoverCopilotStudioEnvironments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one Copilot Studio agent and its components.
         * @summary Get Copilot Studio Agent
         * @param {string} agentId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCopilotStudioAgent(agentId: string, sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopilotStudioAgentDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCopilotStudioAgent(agentId, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.getCopilotStudioAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of supported source types
         * @summary Get Supported Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedSourceTypesForTesting(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceIntegration>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedSourceTypesForTesting(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.getSupportedSourceTypesForTesting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific testing metric by ID
         * @summary Get Testing Metric
         * @param {string} sourceId 
         * @param {string} metricId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestingMetric(sourceId: string, metricId: string, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestingMetric>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestingMetric(sourceId, metricId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.getTestingMetric']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific testing source by ID
         * @summary Get Testing Source
         * @param {string} sourceId 
         * @param {string | null} [projectId] The caller\&#39;s AI System; required to read the global source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestingSource(sourceId: string, projectId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestingSource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestingSource(sourceId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.getTestingSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Available External Metrics of Testing Source
         * @summary Get Available External Metrics of Testing Source
         * @param {string} sourceId 
         * @param {string} metricName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestingSourceExternalMetrics(sourceId: string, metricName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestingMetricExternal>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestingSourceExternalMetrics(sourceId, metricName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.getTestingSourceExternalMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Available Metrics of Testing Source
         * @summary Get Available Metrics of Testing Source
         * @param {string} sourceId 
         * @param {string} projectId 
         * @param {string | null} [metricName] Filter by metric name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestingSourceMetrics(sourceId: string, projectId: string, metricName?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestingMetric>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestingSourceMetrics(sourceId, projectId, metricName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.getTestingSourceMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all testing sources for a project
         * @summary Get Testing Sources
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestingSources(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestingSource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestingSources(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.getTestingSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all tests for a testing source
         * @summary Get Tests
         * @param {string} sourceId 
         * @param {string | null} [projectId] The caller\&#39;s AI System; required to read the global source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestsBySource(sourceId: string, projectId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestingTest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestsBySource(sourceId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.getTestsBySource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List available CloudWatch metrics for a specific AWS resource.
         * @summary List CloudWatch metrics for an AWS resource
         * @param {string} resourceArn 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAwsResourceMetrics(resourceArn: string, sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AWSMetricDefinitionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAwsResourceMetrics(resourceArn, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.listAwsResourceMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List resource groups in an Azure subscription
         * @summary List Azure Resource Groups
         * @param {string} subscriptionId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAzureResourceGroups(subscriptionId: string, sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AzureResourceGroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAzureResourceGroups(subscriptionId, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.listAzureResourceGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List available metrics for an Azure resource
         * @summary List Azure Resource Metrics
         * @param {string} resourceId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAzureResourceMetrics(resourceId: string, sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AzureMetricDefinitionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAzureResourceMetrics(resourceId, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.listAzureResourceMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List Azure subscriptions for a testing source
         * @summary List Azure Subscriptions
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAzureSubscriptions(sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AzureSubscriptionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAzureSubscriptions(sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.listAzureSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List Copilot Studio agents visible to the source\'s service principal.
         * @summary List Copilot Studio Agents
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCopilotStudioAgents(sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopilotStudioAgentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCopilotStudioAgents(sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.listCopilotStudioAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List every Power Platform environment of the source\'s tenant with its agent counts.
         * @summary List Copilot Studio Environments
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCopilotStudioEnvironments(sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopilotStudioEnvironmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCopilotStudioEnvironments(sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.listCopilotStudioEnvironments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List available metrics from the Vijil evaluation.
         * @summary List Vijil Evaluation Metrics
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVijilMetrics(sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VijilMetricDefinitionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVijilMetrics(sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.listVijilMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for AWS resources using tags, types, or name search.
         * @summary Search AWS resources
         * @param {string} sourceId 
         * @param {AWSResourceSearchRequest} aWSResourceSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAwsResources(sourceId: string, aWSResourceSearchRequest: AWSResourceSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AWSResourceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAwsResources(sourceId, aWSResourceSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.searchAwsResources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search Azure resources with optional filters
         * @summary Search Azure Resources
         * @param {string} sourceId 
         * @param {string | null} [subscriptionId] Filter by subscription ID
         * @param {string | null} [resourceGroup] Filter by resource group name
         * @param {string | null} [resourceType] Filter by resource type
         * @param {string | null} [search] Search by resource name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAzureResources(sourceId: string, subscriptionId?: string | null, resourceGroup?: string | null, resourceType?: string | null, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AzureResourceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAzureResources(sourceId, subscriptionId, resourceGroup, resourceType, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.searchAzureResources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test connection to a source before creating it
         * @summary Test Connection
         * @param {string} projectId 
         * @param {TestConnectionRequest} testConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testConnection(projectId: string, testConnectionRequest: TestConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testConnection(projectId, testConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.testConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test connection to an existing testing source using stored credentials
         * @summary Test Existing Source Connection
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testExistingSourceConnection(sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testExistingSourceConnection(sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.testExistingSourceConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a testing source
         * @summary Update Testing Source
         * @param {string} sourceId 
         * @param {UpdateTestingSourceRequest} updateTestingSourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTestingSource(sourceId: string, updateTestingSourceRequest: UpdateTestingSourceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestingSource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTestingSource(sourceId, updateTestingSourceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingSourceApi.updateTestingSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestingSourceApi - factory interface
 */
export const TestingSourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestingSourceApiFp(configuration)
    return {
        /**
         * Run an on-demand connection check for every active source of a project
         * @summary Check All Source Connections
         * @param {TestingSourceApiCheckAllSourceConnectionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAllSourceConnections(requestParameters: TestingSourceApiCheckAllSourceConnectionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceConnectionHealth>> {
            return localVarFp.checkAllSourceConnections(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Probe what the keys of a Claude Enterprise source can read now (one cheap call per API family), store the result on the source and return it.
         * @summary Check Claude Enterprise Capabilities
         * @param {TestingSourceApiCheckClaudeAppsCapabilitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkClaudeAppsCapabilities(requestParameters: TestingSourceApiCheckClaudeAppsCapabilitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaudeAppsCapabilities> {
            return localVarFp.checkClaudeAppsCapabilities(requestParameters.sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Check whether the app can read agents in each picked environment of a tenant source. Checks at most 50 environments per call; the rest are returned as not_checked.
         * @summary Check Copilot Studio Environments
         * @param {TestingSourceApiCheckCopilotStudioEnvironmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCopilotStudioEnvironments(requestParameters: TestingSourceApiCheckCopilotStudioEnvironmentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CopilotStudioEnvironmentChecksResponse> {
            return localVarFp.checkCopilotStudioEnvironments(requestParameters.sourceId, requestParameters.checkCopilotStudioEnvironmentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new testing metric for a testing source
         * @summary Create Testing Metric
         * @param {TestingSourceApiCreateTestingMetricRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestingMetric(requestParameters: TestingSourceApiCreateTestingMetricRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestingMetric> {
            return localVarFp.createTestingMetric(requestParameters.sourceId, requestParameters.projectId, requestParameters.createTestingMetricRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new testing source for a project
         * @summary Create Testing Source
         * @param {TestingSourceApiCreateTestingSourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestingSource(requestParameters: TestingSourceApiCreateTestingSourceRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestingSource> {
            return localVarFp.createTestingSource(requestParameters.projectId, requestParameters.createTestingSourceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a testing source
         * @summary Delete Testing Source
         * @param {TestingSourceApiDeleteTestingSourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTestingSource(requestParameters: TestingSourceApiDeleteTestingSourceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTestingSource(requestParameters.sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * List every Power Platform environment of a tenant with its agent counts, using unsaved credentials.
         * @summary Discover Copilot Studio Environments
         * @param {TestingSourceApiDiscoverCopilotStudioEnvironmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discoverCopilotStudioEnvironments(requestParameters: TestingSourceApiDiscoverCopilotStudioEnvironmentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CopilotStudioEnvironmentsResponse> {
            return localVarFp.discoverCopilotStudioEnvironments(requestParameters.projectId, requestParameters.discoverCopilotStudioEnvironmentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one Copilot Studio agent and its components.
         * @summary Get Copilot Studio Agent
         * @param {TestingSourceApiGetCopilotStudioAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCopilotStudioAgent(requestParameters: TestingSourceApiGetCopilotStudioAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<CopilotStudioAgentDetailResponse> {
            return localVarFp.getCopilotStudioAgent(requestParameters.agentId, requestParameters.sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of supported source types
         * @summary Get Supported Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedSourceTypesForTesting(options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceIntegration>> {
            return localVarFp.getSupportedSourceTypesForTesting(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific testing metric by ID
         * @summary Get Testing Metric
         * @param {TestingSourceApiGetTestingMetricRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingMetric(requestParameters: TestingSourceApiGetTestingMetricRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestingMetric> {
            return localVarFp.getTestingMetric(requestParameters.sourceId, requestParameters.metricId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific testing source by ID
         * @summary Get Testing Source
         * @param {TestingSourceApiGetTestingSourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingSource(requestParameters: TestingSourceApiGetTestingSourceRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestingSource> {
            return localVarFp.getTestingSource(requestParameters.sourceId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Available External Metrics of Testing Source
         * @summary Get Available External Metrics of Testing Source
         * @param {TestingSourceApiGetTestingSourceExternalMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingSourceExternalMetrics(requestParameters: TestingSourceApiGetTestingSourceExternalMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TestingMetricExternal>> {
            return localVarFp.getTestingSourceExternalMetrics(requestParameters.sourceId, requestParameters.metricName, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Available Metrics of Testing Source
         * @summary Get Available Metrics of Testing Source
         * @param {TestingSourceApiGetTestingSourceMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingSourceMetrics(requestParameters: TestingSourceApiGetTestingSourceMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TestingMetric>> {
            return localVarFp.getTestingSourceMetrics(requestParameters.sourceId, requestParameters.projectId, requestParameters.metricName, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all testing sources for a project
         * @summary Get Testing Sources
         * @param {TestingSourceApiGetTestingSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingSources(requestParameters: TestingSourceApiGetTestingSourcesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TestingSource>> {
            return localVarFp.getTestingSources(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all tests for a testing source
         * @summary Get Tests
         * @param {TestingSourceApiGetTestsBySourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestsBySource(requestParameters: TestingSourceApiGetTestsBySourceRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TestingTest>> {
            return localVarFp.getTestsBySource(requestParameters.sourceId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * List available CloudWatch metrics for a specific AWS resource.
         * @summary List CloudWatch metrics for an AWS resource
         * @param {TestingSourceApiListAwsResourceMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAwsResourceMetrics(requestParameters: TestingSourceApiListAwsResourceMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AWSMetricDefinitionResponse>> {
            return localVarFp.listAwsResourceMetrics(requestParameters.resourceArn, requestParameters.sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * List resource groups in an Azure subscription
         * @summary List Azure Resource Groups
         * @param {TestingSourceApiListAzureResourceGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAzureResourceGroups(requestParameters: TestingSourceApiListAzureResourceGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AzureResourceGroupResponse>> {
            return localVarFp.listAzureResourceGroups(requestParameters.subscriptionId, requestParameters.sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * List available metrics for an Azure resource
         * @summary List Azure Resource Metrics
         * @param {TestingSourceApiListAzureResourceMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAzureResourceMetrics(requestParameters: TestingSourceApiListAzureResourceMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AzureMetricDefinitionResponse>> {
            return localVarFp.listAzureResourceMetrics(requestParameters.resourceId, requestParameters.sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * List Azure subscriptions for a testing source
         * @summary List Azure Subscriptions
         * @param {TestingSourceApiListAzureSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAzureSubscriptions(requestParameters: TestingSourceApiListAzureSubscriptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AzureSubscriptionResponse>> {
            return localVarFp.listAzureSubscriptions(requestParameters.sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * List Copilot Studio agents visible to the source\'s service principal.
         * @summary List Copilot Studio Agents
         * @param {TestingSourceApiListCopilotStudioAgentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCopilotStudioAgents(requestParameters: TestingSourceApiListCopilotStudioAgentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CopilotStudioAgentsResponse> {
            return localVarFp.listCopilotStudioAgents(requestParameters.sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * List every Power Platform environment of the source\'s tenant with its agent counts.
         * @summary List Copilot Studio Environments
         * @param {TestingSourceApiListCopilotStudioEnvironmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCopilotStudioEnvironments(requestParameters: TestingSourceApiListCopilotStudioEnvironmentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CopilotStudioEnvironmentsResponse> {
            return localVarFp.listCopilotStudioEnvironments(requestParameters.sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * List available metrics from the Vijil evaluation.
         * @summary List Vijil Evaluation Metrics
         * @param {TestingSourceApiListVijilMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVijilMetrics(requestParameters: TestingSourceApiListVijilMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<VijilMetricDefinitionResponse>> {
            return localVarFp.listVijilMetrics(requestParameters.sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for AWS resources using tags, types, or name search.
         * @summary Search AWS resources
         * @param {TestingSourceApiSearchAwsResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAwsResources(requestParameters: TestingSourceApiSearchAwsResourcesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AWSResourceResponse>> {
            return localVarFp.searchAwsResources(requestParameters.sourceId, requestParameters.aWSResourceSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Search Azure resources with optional filters
         * @summary Search Azure Resources
         * @param {TestingSourceApiSearchAzureResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAzureResources(requestParameters: TestingSourceApiSearchAzureResourcesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AzureResourceResponse>> {
            return localVarFp.searchAzureResources(requestParameters.sourceId, requestParameters.subscriptionId, requestParameters.resourceGroup, requestParameters.resourceType, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * Test connection to a source before creating it
         * @summary Test Connection
         * @param {TestingSourceApiTestConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testConnection(requestParameters: TestingSourceApiTestConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestConnection> {
            return localVarFp.testConnection(requestParameters.projectId, requestParameters.testConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Test connection to an existing testing source using stored credentials
         * @summary Test Existing Source Connection
         * @param {TestingSourceApiTestExistingSourceConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testExistingSourceConnection(requestParameters: TestingSourceApiTestExistingSourceConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestConnection> {
            return localVarFp.testExistingSourceConnection(requestParameters.sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a testing source
         * @summary Update Testing Source
         * @param {TestingSourceApiUpdateTestingSourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestingSource(requestParameters: TestingSourceApiUpdateTestingSourceRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestingSource> {
            return localVarFp.updateTestingSource(requestParameters.sourceId, requestParameters.updateTestingSourceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for checkAllSourceConnections operation in TestingSourceApi.
 */
export interface TestingSourceApiCheckAllSourceConnectionsRequest {
    readonly projectId: string
}

/**
 * Request parameters for checkClaudeAppsCapabilities operation in TestingSourceApi.
 */
export interface TestingSourceApiCheckClaudeAppsCapabilitiesRequest {
    readonly sourceId: string
}

/**
 * Request parameters for checkCopilotStudioEnvironments operation in TestingSourceApi.
 */
export interface TestingSourceApiCheckCopilotStudioEnvironmentsRequest {
    readonly sourceId: string

    readonly checkCopilotStudioEnvironmentsRequest: CheckCopilotStudioEnvironmentsRequest
}

/**
 * Request parameters for createTestingMetric operation in TestingSourceApi.
 */
export interface TestingSourceApiCreateTestingMetricRequest {
    readonly sourceId: string

    readonly projectId: string

    readonly createTestingMetricRequest: CreateTestingMetricRequest
}

/**
 * Request parameters for createTestingSource operation in TestingSourceApi.
 */
export interface TestingSourceApiCreateTestingSourceRequest {
    readonly projectId: string

    readonly createTestingSourceRequest: CreateTestingSourceRequest
}

/**
 * Request parameters for deleteTestingSource operation in TestingSourceApi.
 */
export interface TestingSourceApiDeleteTestingSourceRequest {
    readonly sourceId: string
}

/**
 * Request parameters for discoverCopilotStudioEnvironments operation in TestingSourceApi.
 */
export interface TestingSourceApiDiscoverCopilotStudioEnvironmentsRequest {
    readonly projectId: string

    readonly discoverCopilotStudioEnvironmentsRequest: DiscoverCopilotStudioEnvironmentsRequest
}

/**
 * Request parameters for getCopilotStudioAgent operation in TestingSourceApi.
 */
export interface TestingSourceApiGetCopilotStudioAgentRequest {
    readonly agentId: string

    readonly sourceId: string
}

/**
 * Request parameters for getTestingMetric operation in TestingSourceApi.
 */
export interface TestingSourceApiGetTestingMetricRequest {
    readonly sourceId: string

    readonly metricId: string

    readonly projectId: string
}

/**
 * Request parameters for getTestingSource operation in TestingSourceApi.
 */
export interface TestingSourceApiGetTestingSourceRequest {
    readonly sourceId: string

    /**
     * The caller\&#39;s AI System; required to read the global source
     */
    readonly projectId?: string | null
}

/**
 * Request parameters for getTestingSourceExternalMetrics operation in TestingSourceApi.
 */
export interface TestingSourceApiGetTestingSourceExternalMetricsRequest {
    readonly sourceId: string

    readonly metricName: string
}

/**
 * Request parameters for getTestingSourceMetrics operation in TestingSourceApi.
 */
export interface TestingSourceApiGetTestingSourceMetricsRequest {
    readonly sourceId: string

    readonly projectId: string

    /**
     * Filter by metric name
     */
    readonly metricName?: string | null
}

/**
 * Request parameters for getTestingSources operation in TestingSourceApi.
 */
export interface TestingSourceApiGetTestingSourcesRequest {
    readonly projectId: string
}

/**
 * Request parameters for getTestsBySource operation in TestingSourceApi.
 */
export interface TestingSourceApiGetTestsBySourceRequest {
    readonly sourceId: string

    /**
     * The caller\&#39;s AI System; required to read the global source
     */
    readonly projectId?: string | null
}

/**
 * Request parameters for listAwsResourceMetrics operation in TestingSourceApi.
 */
export interface TestingSourceApiListAwsResourceMetricsRequest {
    readonly resourceArn: string

    readonly sourceId: string
}

/**
 * Request parameters for listAzureResourceGroups operation in TestingSourceApi.
 */
export interface TestingSourceApiListAzureResourceGroupsRequest {
    readonly subscriptionId: string

    readonly sourceId: string
}

/**
 * Request parameters for listAzureResourceMetrics operation in TestingSourceApi.
 */
export interface TestingSourceApiListAzureResourceMetricsRequest {
    readonly resourceId: string

    readonly sourceId: string
}

/**
 * Request parameters for listAzureSubscriptions operation in TestingSourceApi.
 */
export interface TestingSourceApiListAzureSubscriptionsRequest {
    readonly sourceId: string
}

/**
 * Request parameters for listCopilotStudioAgents operation in TestingSourceApi.
 */
export interface TestingSourceApiListCopilotStudioAgentsRequest {
    readonly sourceId: string
}

/**
 * Request parameters for listCopilotStudioEnvironments operation in TestingSourceApi.
 */
export interface TestingSourceApiListCopilotStudioEnvironmentsRequest {
    readonly sourceId: string
}

/**
 * Request parameters for listVijilMetrics operation in TestingSourceApi.
 */
export interface TestingSourceApiListVijilMetricsRequest {
    readonly sourceId: string
}

/**
 * Request parameters for searchAwsResources operation in TestingSourceApi.
 */
export interface TestingSourceApiSearchAwsResourcesRequest {
    readonly sourceId: string

    readonly aWSResourceSearchRequest: AWSResourceSearchRequest
}

/**
 * Request parameters for searchAzureResources operation in TestingSourceApi.
 */
export interface TestingSourceApiSearchAzureResourcesRequest {
    readonly sourceId: string

    /**
     * Filter by subscription ID
     */
    readonly subscriptionId?: string | null

    /**
     * Filter by resource group name
     */
    readonly resourceGroup?: string | null

    /**
     * Filter by resource type
     */
    readonly resourceType?: string | null

    /**
     * Search by resource name
     */
    readonly search?: string | null
}

/**
 * Request parameters for testConnection operation in TestingSourceApi.
 */
export interface TestingSourceApiTestConnectionRequest {
    readonly projectId: string

    readonly testConnectionRequest: TestConnectionRequest
}

/**
 * Request parameters for testExistingSourceConnection operation in TestingSourceApi.
 */
export interface TestingSourceApiTestExistingSourceConnectionRequest {
    readonly sourceId: string
}

/**
 * Request parameters for updateTestingSource operation in TestingSourceApi.
 */
export interface TestingSourceApiUpdateTestingSourceRequest {
    readonly sourceId: string

    readonly updateTestingSourceRequest: UpdateTestingSourceRequest
}

/**
 * TestingSourceApi - object-oriented interface
 */
export class TestingSourceApi extends BaseAPI {
    /**
     * Run an on-demand connection check for every active source of a project
     * @summary Check All Source Connections
     * @param {TestingSourceApiCheckAllSourceConnectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkAllSourceConnections(requestParameters: TestingSourceApiCheckAllSourceConnectionsRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).checkAllSourceConnections(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Probe what the keys of a Claude Enterprise source can read now (one cheap call per API family), store the result on the source and return it.
     * @summary Check Claude Enterprise Capabilities
     * @param {TestingSourceApiCheckClaudeAppsCapabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkClaudeAppsCapabilities(requestParameters: TestingSourceApiCheckClaudeAppsCapabilitiesRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).checkClaudeAppsCapabilities(requestParameters.sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check whether the app can read agents in each picked environment of a tenant source. Checks at most 50 environments per call; the rest are returned as not_checked.
     * @summary Check Copilot Studio Environments
     * @param {TestingSourceApiCheckCopilotStudioEnvironmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkCopilotStudioEnvironments(requestParameters: TestingSourceApiCheckCopilotStudioEnvironmentsRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).checkCopilotStudioEnvironments(requestParameters.sourceId, requestParameters.checkCopilotStudioEnvironmentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new testing metric for a testing source
     * @summary Create Testing Metric
     * @param {TestingSourceApiCreateTestingMetricRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTestingMetric(requestParameters: TestingSourceApiCreateTestingMetricRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).createTestingMetric(requestParameters.sourceId, requestParameters.projectId, requestParameters.createTestingMetricRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new testing source for a project
     * @summary Create Testing Source
     * @param {TestingSourceApiCreateTestingSourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTestingSource(requestParameters: TestingSourceApiCreateTestingSourceRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).createTestingSource(requestParameters.projectId, requestParameters.createTestingSourceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a testing source
     * @summary Delete Testing Source
     * @param {TestingSourceApiDeleteTestingSourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTestingSource(requestParameters: TestingSourceApiDeleteTestingSourceRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).deleteTestingSource(requestParameters.sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List every Power Platform environment of a tenant with its agent counts, using unsaved credentials.
     * @summary Discover Copilot Studio Environments
     * @param {TestingSourceApiDiscoverCopilotStudioEnvironmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public discoverCopilotStudioEnvironments(requestParameters: TestingSourceApiDiscoverCopilotStudioEnvironmentsRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).discoverCopilotStudioEnvironments(requestParameters.projectId, requestParameters.discoverCopilotStudioEnvironmentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one Copilot Studio agent and its components.
     * @summary Get Copilot Studio Agent
     * @param {TestingSourceApiGetCopilotStudioAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCopilotStudioAgent(requestParameters: TestingSourceApiGetCopilotStudioAgentRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).getCopilotStudioAgent(requestParameters.agentId, requestParameters.sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of supported source types
     * @summary Get Supported Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSupportedSourceTypesForTesting(options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).getSupportedSourceTypesForTesting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific testing metric by ID
     * @summary Get Testing Metric
     * @param {TestingSourceApiGetTestingMetricRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTestingMetric(requestParameters: TestingSourceApiGetTestingMetricRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).getTestingMetric(requestParameters.sourceId, requestParameters.metricId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific testing source by ID
     * @summary Get Testing Source
     * @param {TestingSourceApiGetTestingSourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTestingSource(requestParameters: TestingSourceApiGetTestingSourceRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).getTestingSource(requestParameters.sourceId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Available External Metrics of Testing Source
     * @summary Get Available External Metrics of Testing Source
     * @param {TestingSourceApiGetTestingSourceExternalMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTestingSourceExternalMetrics(requestParameters: TestingSourceApiGetTestingSourceExternalMetricsRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).getTestingSourceExternalMetrics(requestParameters.sourceId, requestParameters.metricName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Available Metrics of Testing Source
     * @summary Get Available Metrics of Testing Source
     * @param {TestingSourceApiGetTestingSourceMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTestingSourceMetrics(requestParameters: TestingSourceApiGetTestingSourceMetricsRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).getTestingSourceMetrics(requestParameters.sourceId, requestParameters.projectId, requestParameters.metricName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all testing sources for a project
     * @summary Get Testing Sources
     * @param {TestingSourceApiGetTestingSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTestingSources(requestParameters: TestingSourceApiGetTestingSourcesRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).getTestingSources(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all tests for a testing source
     * @summary Get Tests
     * @param {TestingSourceApiGetTestsBySourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTestsBySource(requestParameters: TestingSourceApiGetTestsBySourceRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).getTestsBySource(requestParameters.sourceId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List available CloudWatch metrics for a specific AWS resource.
     * @summary List CloudWatch metrics for an AWS resource
     * @param {TestingSourceApiListAwsResourceMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAwsResourceMetrics(requestParameters: TestingSourceApiListAwsResourceMetricsRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).listAwsResourceMetrics(requestParameters.resourceArn, requestParameters.sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List resource groups in an Azure subscription
     * @summary List Azure Resource Groups
     * @param {TestingSourceApiListAzureResourceGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAzureResourceGroups(requestParameters: TestingSourceApiListAzureResourceGroupsRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).listAzureResourceGroups(requestParameters.subscriptionId, requestParameters.sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List available metrics for an Azure resource
     * @summary List Azure Resource Metrics
     * @param {TestingSourceApiListAzureResourceMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAzureResourceMetrics(requestParameters: TestingSourceApiListAzureResourceMetricsRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).listAzureResourceMetrics(requestParameters.resourceId, requestParameters.sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List Azure subscriptions for a testing source
     * @summary List Azure Subscriptions
     * @param {TestingSourceApiListAzureSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAzureSubscriptions(requestParameters: TestingSourceApiListAzureSubscriptionsRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).listAzureSubscriptions(requestParameters.sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List Copilot Studio agents visible to the source\'s service principal.
     * @summary List Copilot Studio Agents
     * @param {TestingSourceApiListCopilotStudioAgentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCopilotStudioAgents(requestParameters: TestingSourceApiListCopilotStudioAgentsRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).listCopilotStudioAgents(requestParameters.sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List every Power Platform environment of the source\'s tenant with its agent counts.
     * @summary List Copilot Studio Environments
     * @param {TestingSourceApiListCopilotStudioEnvironmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCopilotStudioEnvironments(requestParameters: TestingSourceApiListCopilotStudioEnvironmentsRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).listCopilotStudioEnvironments(requestParameters.sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List available metrics from the Vijil evaluation.
     * @summary List Vijil Evaluation Metrics
     * @param {TestingSourceApiListVijilMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listVijilMetrics(requestParameters: TestingSourceApiListVijilMetricsRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).listVijilMetrics(requestParameters.sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for AWS resources using tags, types, or name search.
     * @summary Search AWS resources
     * @param {TestingSourceApiSearchAwsResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchAwsResources(requestParameters: TestingSourceApiSearchAwsResourcesRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).searchAwsResources(requestParameters.sourceId, requestParameters.aWSResourceSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search Azure resources with optional filters
     * @summary Search Azure Resources
     * @param {TestingSourceApiSearchAzureResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchAzureResources(requestParameters: TestingSourceApiSearchAzureResourcesRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).searchAzureResources(requestParameters.sourceId, requestParameters.subscriptionId, requestParameters.resourceGroup, requestParameters.resourceType, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test connection to a source before creating it
     * @summary Test Connection
     * @param {TestingSourceApiTestConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public testConnection(requestParameters: TestingSourceApiTestConnectionRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).testConnection(requestParameters.projectId, requestParameters.testConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test connection to an existing testing source using stored credentials
     * @summary Test Existing Source Connection
     * @param {TestingSourceApiTestExistingSourceConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public testExistingSourceConnection(requestParameters: TestingSourceApiTestExistingSourceConnectionRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).testExistingSourceConnection(requestParameters.sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a testing source
     * @summary Update Testing Source
     * @param {TestingSourceApiUpdateTestingSourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTestingSource(requestParameters: TestingSourceApiUpdateTestingSourceRequest, options?: RawAxiosRequestConfig) {
        return TestingSourceApiFp(this.configuration).updateTestingSource(requestParameters.sourceId, requestParameters.updateTestingSourceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

